module.exports = __webpack_public_path__ + "img/Gefahr.264a15d4.svg";